// extracted by mini-css-extract-plugin
module.exports = {"section":"DimensionHeroContentBlock_section__7KFsr","title":"DimensionHeroContentBlock_title__RPTJo","tableContainer":"DimensionHeroContentBlock_tableContainer__eJh7x"};